import axios from 'axios'
import Element from 'element-ui'
import qs from 'qs'

axios.defaults.withCredentials = true
axios.defaults.timeout = 50000
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

let isTokenExpired = false
let hasShownExpiredMessage = false

axios.interceptors.request.use(
  function (config) {
    const fyToken = localStorage.getItem('fy-token')

    if (fyToken) {
      config.headers['fy-token'] = fyToken
      config.timeout = 300000
    }

    const urlAuth = ['release']
    const whitelist = ['need', 'pyadver']
    const urlPath = config.url

    if (urlPath == '/admin/users/login/login') {
      isTokenExpired = false
      hasShownExpiredMessage = false
    }

    if (
      isTokenExpired &&
      ['/admin/verify/captcha/refresh', '/login/getVerify', '/admin/users/login/login'].indexOf(
        urlPath
      ) == -1
    ) {
      return Promise.reject(new Error('登录状态过期，请重新登录！'))
    }

    const mediaId = localStorage.getItem('mediaId')
    const urlArr = urlPath.split('/')

    const blobList = [
      'login/getVerify',
      '/admin/customers/export/exporttemplate',
      '/admin/customers/export/downloadinvoice',
      '/admin/customers/export/exporterrorexcel',
      '/admin/customers/export/exportcontractexcel',
      '/admin/customers/export/exportinvoiceexcel',
      '/admin/customers/export/exportbankcardexcel',
      '/admin/customers/export/exportExecuteduizhangexcel',
      '/admin/customers/export/exportplateforminvoiceexcel',
      '/admin/customers/export/exportreportexcel',
    ]

    if (blobList.indexOf(urlPath) != -1) {
      config.responseType = 'blob'
    }

    if (urlPath == 'need/submitorder') {
      config.headers['Content-Type'] = 'multipart/form-data'
    }

    if (urlPath == '/admin/verify/captcha/refresh') {
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
    }

    if (whitelist.indexOf(urlArr[0]) != -1) {
      config.baseURL = process.env.VUE_APP_BASE_PYTHON
    } else if (!urlArr[0]) {
      config.baseURL = process.env.VUE_APP_BASE_API_content
    } else {
      config.baseURL = process.env.VUE_APP_BASE_API
    }

    if (config.method == 'post') {
      if (whitelist.indexOf(urlArr[0]) != -1 || !urlArr[0]) {
        config.dataSerializer = function (data) {
          return qs.stringify(data, { arrayFormat: 'repeat' })
        }
      } else {
        if (mediaId && urlAuth.indexOf(urlArr[0]) != -1) {
          config.data = {
            mediaId: localStorage.getItem('mediaId'),
            ...config.data,
          }
        }
        if (!config.data) {
          config.data = {}
        }
        config.data = qs.stringify(config.data)
      }
    } else if (config.method == 'get') {
      config.paramsSerializer = function (params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
      if (mediaId && urlAuth.indexOf(urlArr[0]) != -1) {
        config.params = {
          mediaId: localStorage.getItem('mediaId'),
          ...config.params,
        }
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  function (response) {
    switch (response.status) {
      case 200:
        return response.data
      case 207:
        return response
      default:
        Element.Message.error([], response.statusText)
    }
  },
  error => {
    if (error.response && error.response.status == 403) {
      isTokenExpired = true
      if (!hasShownExpiredMessage) {
        hasShownExpiredMessage = true
        Element.Message.error(error.response.data.msg)
        window.location.href = '/#/login'
      }
    }
    if (error.response && error.response.status == 404) {
      isTokenExpired = true
      if (!hasShownExpiredMessage) {
        hasShownExpiredMessage = true
        window.location.href = '/#/login'
      }
    }
    return Promise.reject(error)
  }
)

export default axios
